// extracted by mini-css-extract-plugin
module.exports = {"iconCurrency":"EditProject_iconCurrency_2jRuG","iconLocalization":"EditProject_iconLocalization_RE3_S"};